/**
 * @generated SignedSource<<5068d76754b722b425f5ed8d488e33db>>
 * @relayHash 7794c32f565bb65ec1d58cdfe2cd7c65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 815e8e86601de719f9d0106d420dba00c2dd02b64bc8e63048a0b261dccf95a2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type viewBacklogVersionFilterRelayQuery$variables = {
  after?: string | null | undefined;
  first: number;
  jiraProjectIds: ReadonlyArray<string>;
};
export type viewBacklogVersionFilterRelayQuery$data = {
  readonly jira: {
    readonly versionsForProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly versionId: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"versionFilterRelay_softwareFilters">;
      } | null | undefined>;
    };
  };
};
export type viewBacklogVersionFilterRelayQuery = {
  response: viewBacklogVersionFilterRelayQuery$data;
  variables: viewBacklogVersionFilterRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraProjectIds"
},
v3 = {
  "kind": "Literal",
  "name": "filter",
  "value": [
    "UNRELEASED"
  ]
},
v4 = {
  "kind": "Variable",
  "name": "jiraProjectIds",
  "variableName": "jiraProjectIds"
},
v5 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v8 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v4/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "viewBacklogVersionFilterRelayQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "versionsForProjects",
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraVersionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "versionFilterRelay_softwareFilters"
                        },
                        {
                          "concreteType": "JiraVersion",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v5/*: any*/),
                            (v6/*: any*/)
                          ]
                        },
                        (v7/*: any*/)
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.versionsForProjects.edges"
                  },
                  (v8/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.versionsForProjects"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "viewBacklogVersionFilterRelayQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          (v10/*: any*/)
                        ]
                      },
                      (v10/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ]
              },
              (v8/*: any*/)
            ]
          },
          {
            "args": (v9/*: any*/),
            "filters": [
              "jiraProjectIds",
              "filter"
            ],
            "handle": "connection",
            "key": "versionBacklogPanelRelay_versionsForProjects",
            "kind": "LinkedHandle",
            "name": "versionsForProjects"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "815e8e86601de719f9d0106d420dba00c2dd02b64bc8e63048a0b261dccf95a2",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "versionsForProjects"
          ]
        }
      ]
    },
    "name": "viewBacklogVersionFilterRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8f0feba2d091a19a39a14c5133920950";

export default node;
